module.exports = __webpack_public_path__ + "static/media/jackpot.151f9284.png";